import React from "react";
import styled from "styled-components";
import omit from "lodash.omit";
import Img from "react-image";

import fbmLogo from "../../img/fbm-mini-logo.svg";

type Props = {
  src: string
};

const propsToOmit = ["src"];

const User = (props: Props) => (
  <Wrap {...omit(props, propsToOmit)}>
    <StyledImg src={props.src} />
    <FbmLogo src={fbmLogo} alt="Facebook Messenger" className="user-fbm-logo" />
  </Wrap>
);

export default User;

// Styled Components
const Wrap = styled.div`
  position: relative;
  width: 40px;
`;

const StyledImg = styled(Img)`
  border: 1px solid rgba(77, 80, 82, 0.13);
  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.08);
  border-radius: 100%;
  height: 40px;
  opacity: 0.73;
  width: 40px;
`;

const FbmLogo = styled(Img)`
  bottom: 6px;
  position: absolute;
  right: -2px;
`;



// WEBPACK FOOTER //
// ./src/components/Users/User.jsx